import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

export interface RealtimeFeedItem {
  id: string;
  type: string;
  title: string;
  text: string;
  source: string;
  senderId?: string;
  iconColor: string;
  icon: string;
  rosterId?: string;
  shiftId?: string;
  isRead: boolean;
  createdOnUtc: string;
}

export interface RealtimeFeedPage {
  items: RealtimeFeedItem[];
  hasMore: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class RealtimeFeedService {
  constructor(private apiService: ApiService) {}

  getFeed(take = 30, beforeCreatedOnUtc?: string, beforeId?: string) {
    let path = `/RealtimeFeed?take=${take}&isNoLoading=true`;
    if (beforeCreatedOnUtc && beforeId) {
      path += `&beforeCreatedOnUtc=${encodeURIComponent(beforeCreatedOnUtc)}&beforeId=${beforeId}`;
    }
    return this.apiService.get(path);
  }

  markAllRead() {
    return this.apiService.post('/RealtimeFeed/mark-all-read?isNoLoading=true');
  }

  markRead(id: string) {
    return this.apiService.post(`/RealtimeFeed/${id}/read?isNoLoading=true`);
  }

  logChatMessage(model: {
    isGroup: boolean;
    groupId?: string;
    recipientId?: string;
    text: string;
    messageType: string;
    isPtt: boolean;
  }) {
    return this.apiService.post('/RealtimeFeed/chat-message?isNoLoading=true', model);
  }
}
